import { PatientEntitlementToMedicalServiceStatus } from '~libs.shared.patient-entitlement-to-medical-service';
import { hasOneElement } from '~libs.typescript';

import { AdditionalEntitlement, Reimbursement } from '../types';

import { hasReimbursementFull } from './reimbursement';
import { hasAdditionalEntitlementType } from './additionalEntitlements';

type Prescriptions = {
   reimbursement: Reimbursement;
   additionalEntitlements: AdditionalEntitlement[] | null;
};

export const isPatientEligibleForBenefit = (
   patientEntitlementToMedicalServiceStatus: PatientEntitlementToMedicalServiceStatus,
   prescriptions: Prescriptions[]
): boolean => {
   return (
      patientEntitlementToMedicalServiceStatus.entitlementStatementStatus === 'VALID_ENTITLEMENT_STATEMENT' ||
      patientEntitlementToMedicalServiceStatus.ewusStatus === 'INSURED' ||
      prescriptions.every(
         ({ reimbursement, additionalEntitlements }) =>
            hasReimbursementFull(reimbursement) ||
            hasAdditionalEntitlementType('DN', additionalEntitlements) ||
            (hasOneElement(additionalEntitlements) && hasAdditionalEntitlementType('IN', additionalEntitlements))
      )
   );
};
